import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../services/deliveryService";

export interface DeliveryReportV2Params {
  page: number;
  pageSize: number;
  sort?: any;
  search?: string;
  states?: string[];
  statuses?: string[];
  salesName?: string;
  onlyToday?: boolean;
  fetchAll?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  profile: string;
  city: string;
}

export const getDeliveryReportV2 = createAsyncThunk(
  "delivery/reportV2",
  async (params: DeliveryReportV2Params, { getState, rejectWithValue }) => {
    try {
      const { data } = await API.getDeliveryReportV2({
        ...params,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export interface DeliveryAttachmentsListParams {
  page: number;
  pageSize: number;
  sort?: string;
  search?: string;
}

export const getDeliveryAttachmentsList = createAsyncThunk(
  "delivery/attachmentsList",
  async (params: DeliveryAttachmentsListParams, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort = "-createdAt", search = "" } = params;
      const { data } = await API.getAllDeliveryAttachments(
        page,
        pageSize,
        sort,
        search,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
